import { decimalOddsValuesMap } from "../constants";

export const convertOdds = ({ odds, type }) => {
  if (odds === "Infinity" || odds === Infinity) {
    return null;
  }

  if (!Number.isInteger(odds)) {
    return odds;
  }

  if (
    !odds ||
    (type === "min" && odds === 0) ||
    (type === "max" && odds === decimalOddsValuesMap.size - 1)
  ) {
    return null;
  }

  return decimalOddsValuesMap.get(odds);
};

export function convertPositionToDecimal(position) {
  if (position === 0) {
    return null;
  }
  if (position === decimalOddsValuesMap.size - 1) {
    return Infinity;
  }
  return decimalOddsValuesMap.get(position);
}
